import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=c239316a&scoped=true&"
import script from "./TeamMemberCard.vue?vue&type=script&lang=js&"
export * from "./TeamMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberCard.vue?vue&type=style&index=0&id=c239316a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c239316a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDivider,VIcon,VImg,VSpacer})
